module.exports = __webpack_public_path__ + "static/media/number7.b0e28873.svg";